module.exports = __webpack_public_path__ + "static/media/gandalf-signin.672a6ab9.png";